export enum GmpObjectOperation {
  CREATE = 'GMP-Create',
  REJECT = 'GMP-Reject',
  REGISTER = 'GMP-Register',
  SUSPEND = 'GMP-Suspend',
  RESUME = 'GMP-Resume',
  CANCEL = 'GMP-Cancel',
  TERMINATE = 'GMP-Terminate',
}

export enum GmpObjectStatus {
  ACCEPTED = 'GMP-Accepted',
  REJECTED = 'GMP-Rejected',
  REGISTERED = 'GMP-Registered',
  CANCELED = 'GMP-Canceled',
  TERMINATED = 'GMP-Terminated',
  SUSPENDED = 'GMP-Suspended',
}
